export const newsStories = [
  {
    id: 'voices-of-impact-nyc',
    category: 'Leadership',
    date: '2026-09-25',
    readTime: '3 min read',
    title: 'From L.A. to NYC: Hondurans In LA takes the stage at Voices of Impact',
    excerpt:
      'We’ve been invited to the Honduran-American Summit in New York, where our Executive Director Dolly Figueroa joins a panel of diaspora leaders.',
    image: 'https://cdn.magicpatterns.com/uploads/jatuUd7zZmjMgV5JCHEL1P/Image_Holder_Main.png',
    link: {
      href: 'https://hondurasusa.org/#/voices-of-impact-ny',
      label: 'See the event',
    },
    gallery: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/67BXq6pm1cuDZDgJTVY3sz/13.png',
        alt: 'Catracho/a Chats with Dunia Elvir and Dolly Figueroa — October 2, 2026, New York, NY',
        caption: 'Catracho/a Chats — October 2, New York',
      },
    ],
    body: [
      'Big news, familia: Hondurans In LA has been invited to the Honduran-American Summit in New York City — Voices of Impact, a Hispanic Heritage Month celebration cohosted by the Honduran American Association.',
      'On October 2, 2026, our Executive Director Dolly Figueroa will take the stage alongside fellow leaders of Honduran diaspora organizations from across the country. The conversation will be moderated by Dunia Elvir, President of the National Association of Hispanic Journalists (NAHJ).',
      'This moment is bigger than one panel. It’s coast-to-coast proof that the Honduran diaspora is organized, connected, and ready to lead — from the palm trees of L.A. to the skyline of New York. When our leaders share a stage, our communities share a vision.',
      'Dolly is bringing Los Angeles with her: our culture, our small businesses, our young people, and the coalition we’ve been building block by block. Community. Leadership. Opportunity. ¡Juntos más fuertes!',
    ],
  },
  {
    id: 'independence-day',
    category: 'Culture',
    date: '2026-09-15',
    readTime: '4 min read',
    title: '¡Feliz Día de la Independencia! Celebrating Honduras in the heart of L.A.',
    excerpt:
      'Flags up, music loud. Our community came together to honor Honduran independence with food, art, and familia.',
    image: 'https://cdn.magicpatterns.com/uploads/wBi4SphJsaRYDcDLYQz3ib/IMG_0545_2.jpg',
    imagePosition: 'center 30%',
    body: [
      'Every September 15th, Hondurans everywhere celebrate the day our nation claimed its independence. Here in Los Angeles, that celebration is a reminder of how far our roots reach.',
      'This year, families, creators, and neighbors gathered to share baleadas, music, and stories that connect us to home — and to each other.',
      'Moments like these are exactly why Hondurans In LA exists: to create spaces where our community connects, learns, and takes pride in its heritage.',
    ],
  },
  {
    id: 'cavff-eva',
    category: 'Film',
    date: '2026-09-12',
    readTime: '3 min read',
    title: 'Lights, camera, Catrachos: Honduran cinema takes Hollywood at CAVFF',
    excerpt:
      'We pulled up to the Central American Voices Film Festival as the Honduran film EVA lit up opening night in Hollywood.',
    image: 'https://cdn.magicpatterns.com/uploads/5wRJaAgE3jpHjPB7f2NhXJ/Screenshot_2026-09-26_at_12.07.18_AM.png',
    imagePosition: 'center 28%',
    gallery: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/4SZP5emy5MacSXz76hP9Tx/Eva_Movie.jpg',
        alt: 'Poster for EVA, a film by William Reyes — opening night presentation at Barnsdall Gallery Theatre, Hollywood, September 12',
        caption: 'EVA, a film by William Reyes',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/tk7naQi7QFhU7arNd1HFYv/Cavff_logo.jpg',
        alt: 'Central American Voices Film Festival artwork',
        caption: 'Central American Voices Film Festival',
      },
    ],
    body: [
      'Our stories deserve the big screen. On September 12, Hondurans In LA showed up for the Central American Voices Film Festival (CAVFF) — a celebration of the filmmakers, artists, and storytellers shaping how the world sees our region.',
      'And opening night? Pure Catracho pride. The Honduran film EVA, directed by William Reyes, took the spotlight at the Barnsdall Gallery Theatre in Hollywood. Seeing a Honduran story open the festival, in the heart of the film capital of the world, hit different.',
      'For too long, Central American voices have been left off the marquee. Nights like this flip the script — our faces, our language, our landscapes, told by us and celebrated by a packed room of people who get it.',
      'To every young Honduran in L.A. with a camera, a notebook, or just a story in your head: this is your sign. The screen is waiting. Hondurans In LA will keep showing up, cheering loud, and opening doors so the next EVA is yours.',
    ],
  },
  {
    id: 'presence-in-community',
    category: 'Community',
    date: '2026-09-23',
    readTime: '3 min read',
    title: 'Making our presence known in the community',
    excerpt:
      'Flags up, table set, doors open. Why creating spaces for the next generation of Hondurans in L.A. matters more than ever.',
    image: 'https://cdn.magicpatterns.com/uploads/7d4TmWj5EVRtdNTPHxVJCZ/Screenshot_2026-09-26_at_12.12.46_AM.png',
    imagePosition: 'center 30%',
    body: [
      'You’ve probably seen us by now — the orange-and-pink table, the five blue stars, the little Honduran flags waving in the breeze. Showing up at community events across Los Angeles is about more than handing out flyers. It’s about saying, loud and clear: Hondurans are here, and we belong here.',
      'For a lot of young Hondurans growing up in L.A., it’s easy to feel like the only Catracho in the room. That’s exactly why these spaces matter. When a kid walks up to our table and sees people who look like them, talk like their family, and carry the same flag with pride, something clicks. Connection starts there.',
      'Representation isn’t a buzzword — it’s fuel. Seeing Honduran women leading, Honduran creators building, and Honduran families celebrating out in the open shows the next generation what’s possible. It tells them their story is worth telling and their dreams are within reach.',
      'And it keeps our roots alive. Every conversation, every flag, every “¿y tu familia de dónde es?” is a thread back to home — to our food, our music, our history, our people. We want the next generation to wear that heritage like a badge of honor.',
      'So we’ll keep setting up the table. We’ll keep creating spaces where young Hondurans can connect with each other, be empowered by seeing others like them, and celebrate who they are. Come find us at the next one — there’s a seat, and a flag, waiting for you.',
    ],
  },
  {
    id: 'macarthur-park-cleanup',
    category: 'Community',
    date: '2026-09-23',
    readTime: '3 min read',
    title: 'Gloves on, brooms up: showing love to MacArthur Park — together',
    excerpt:
      'We joined community partners for a MacArthur Park clean-up, because community is built together — never in silos.',
    image: 'https://cdn.magicpatterns.com/uploads/tdCjXxXAKzFSPWrnMoCC8M/Screenshot_2026-09-26_at_12.09.15_AM.png',
    imagePosition: 'center 45%',
    body: [
      'MacArthur Park is more than a park. For generations of Central American families in Los Angeles, it has been a gathering place, a first stop, a piece of home. So when it was time to give it some love, Hondurans In LA showed up — gloves on, brooms up, bags ready.',
      'We didn’t do it alone, and that’s the point. We rolled in alongside community partners and neighbors from across the city, side by side under the palm trees, filling bag after bag and trading stories along the way.',
      'We believe community is built together, not in silos. No single organization can do it all — but when we pull in the same direction, the impact multiplies. That’s why we are intentional about doing this work in community: showing up for each other, sharing the load, and building relationships that last longer than a single Saturday.',
      'A cleaner park is the win you can see. The bigger win is the web of people who now know each other’s names. Want in on the next one? Join the familia — there’s always a pair of gloves with your name on it.',
    ],
  },
];
